import styled from 'styled-components';

import { ThemeProp } from '~/theme/Themes';

export const PeopleCountText = styled.div`
  margin-top: 0.5rem;
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xs};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.semibold};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.c500};
`;
